<template>
  <UiText type="small" class="mt-1 block text-negative-700">
    {{ message }}
  </UiText>
</template>

<script setup lang="ts">
import type { ErrorMessageProps } from '~/components/ui/ErrorMessage/types';

defineProps<ErrorMessageProps>();
</script>
